import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.object.to-string.js";
import { getMyToDoCount, getAllToDoCount, getMyReviewAuditCount } from '../api';
import { getMyToDoDefaultForm, getAllToDoDefaultForm, getMyReviewDefaultForm, getQuotationDefaultForm, getTicketDefaultForm, getCardMakePrintDefaultForm, getTaskStatusOptionsCached } from './defaultForms';
export default function createDeliveryCountMixin(permissions) {
  return {
    data: function data() {
      return {
        taskStatusOptions: [],
        // 全部任务状态选项，全部待办计数依赖其 checked 默认值
        toDoCount: 0,
        allToDoCount: 0,
        reviewCount: 0,
        reviewProjectCount: 0,
        reviewMallCount: 0,
        reviewBiddingCount: 0,
        reviewPrintingCount: 0,
        toDoProjectCount: 0,
        toDoMallCount: 0,
        toDoBiddingCount: 0,
        toDoPrintingCount: 0,
        toDoTicketCount: 0,
        allProjectCount: 0,
        allTaskCount: 0,
        allToDoMallCount: 0,
        allToDoBiddingCount: 0,
        allToDoPrintingCount: 0,
        allToDoTicketCount: 0,
        allToDoCardPrintCount: 0,
        reviewTicketCount: 0,
        reviewQuotationCount: 0,
        reviewQuotationBindCount: 0,
        toDoQuotationCount: 0,
        allToDoQuotationCount: 0
      };
    },
    mounted: function mounted() {
      var _this = this;
      // 全部待办的任务默认状态来自接口选项（checked 项），
      // 需先加载选项再统一拉取角标，避免先用空选项发起一次参数错误的计数请求
      if (this.hasAnyRole(permissions.allToDo)) {
        getTaskStatusOptionsCached().then(function (list) {
          _this.taskStatusOptions = list;
        }).catch(function () {}).then(function () {
          return _this.getCounts();
        });
      } else {
        this.getCounts();
      }
    },
    methods: {
      // 权限项支持字符串或数组（数组表示任一命中即可，用于项目/工单权限并存的 tab）
      hasAnyRole: function hasAnyRole(perms) {
        var _this2 = this;
        return [].concat(perms || []).some(function (item) {
          return _this2.$hasBtnRoles(item);
        });
      },
      toNumber: function toNumber(value) {
        var number = parseFloat(value);
        return isNaN(number) ? 0 : number;
      },
      fetchMyToDoCount: function fetchMyToDoCount(paramsOverride) {
        var _this3 = this;
        var params = {
          project: getMyToDoDefaultForm('project'),
          mall: getMyToDoDefaultForm('mall'),
          bidding: getMyToDoDefaultForm('bidding'),
          card: getMyToDoDefaultForm('card'),
          ticket: getTicketDefaultForm('myToDo'),
          quotation: getQuotationDefaultForm('myToDo')
        };
        if (paramsOverride && paramsOverride.tabKey && paramsOverride.searchForm) {
          params[paramsOverride.tabKey] = paramsOverride.searchForm;
        }
        getMyToDoCount(params).then(function (res) {
          var data = res.data || {};
          _this3.toDoProjectCount = _this3.toNumber(data.my_to_do_project_count);
          _this3.toDoMallCount = _this3.toNumber(data.my_to_do_mall_count);
          _this3.toDoBiddingCount = _this3.toNumber(data.my_to_do_bidding_count);
          _this3.toDoPrintingCount = _this3.toNumber(data.my_to_do_printing_count);
          _this3.toDoTicketCount = _this3.toNumber(data.my_to_do_ticket_count);
          _this3.toDoQuotationCount = _this3.toNumber(data.my_to_do_question_count);
          _this3.toDoCount = _this3.toDoBiddingCount + _this3.toDoMallCount + _this3.toDoProjectCount + _this3.toDoPrintingCount + _this3.toDoTicketCount + _this3.toDoQuotationCount;
        });
      },
      fetchAllToDoCount: function fetchAllToDoCount(paramsOverride) {
        var _this4 = this;
        var params = {
          project: getAllToDoDefaultForm('project', this.taskStatusOptions),
          task: getAllToDoDefaultForm('task', this.taskStatusOptions),
          mall: getAllToDoDefaultForm('mall', this.taskStatusOptions),
          bidding: getAllToDoDefaultForm('bidding', this.taskStatusOptions),
          card: getAllToDoDefaultForm('card', this.taskStatusOptions),
          ticket: getTicketDefaultForm('allToDo'),
          quotation: getQuotationDefaultForm('allToDo'),
          card_make_print: getCardMakePrintDefaultForm()
        };
        if (paramsOverride && paramsOverride.tabKey && paramsOverride.searchForm) {
          params[paramsOverride.tabKey] = paramsOverride.searchForm;
        }
        getAllToDoCount(params).then(function (res) {
          var data = res.data || {};
          _this4.allProjectCount = _this4.toNumber(data.all_project_list_count);
          _this4.allTaskCount = _this4.toNumber(data.all_task_list_count);
          _this4.allToDoMallCount = _this4.toNumber(data.all_to_do_mall_count);
          _this4.allToDoBiddingCount = _this4.toNumber(data.all_to_do_bidding_count);
          _this4.allToDoPrintingCount = _this4.toNumber(data.all_to_do_printing_count);
          _this4.allToDoTicketCount = _this4.toNumber(data.all_to_do_ticket_count);
          _this4.allToDoCardPrintCount = _this4.toNumber(data.all_to_do_card_print_count);
          _this4.allToDoQuotationCount = _this4.toNumber(data.all_to_do_quotation_count);
          // 全部待办角标按可见子 tab 汇总：用户可能没有全部任务列表权限，
          // 用全部任务列表汇总会导致顶层统计不准确
          _this4.allToDoCount = _this4.allProjectCount + _this4.allToDoMallCount + _this4.allToDoBiddingCount + _this4.allToDoPrintingCount + _this4.allToDoCardPrintCount + _this4.allToDoTicketCount + _this4.allToDoQuotationCount;
        });
      },
      fetchMyReviewCount: function fetchMyReviewCount(paramsOverride) {
        var _this5 = this;
        var myReviewForm = getMyReviewDefaultForm();
        var params = {
          project: myReviewForm,
          mall: myReviewForm,
          card: myReviewForm,
          ticket: getTicketDefaultForm('myReview'),
          quotation: getQuotationDefaultForm()
        };
        if (paramsOverride && paramsOverride.tabKey && paramsOverride.searchForm) {
          // 报价单审核(quotation)/分发(quotationBind)两个子 tab 共用 quotation 计数参数
          var tabKey = paramsOverride.tabKey === 'quotationBind' ? 'quotation' : paramsOverride.tabKey;
          params[tabKey] = paramsOverride.searchForm;
        }
        getMyReviewAuditCount(params).then(function (res) {
          var data = res.data || {};
          _this5.reviewProjectCount = _this5.toNumber(data.my_audit_project_list_count);
          _this5.reviewMallCount = _this5.toNumber(data.my_to_do_mall_count);
          _this5.reviewPrintingCount = _this5.toNumber(data.my_to_do_printing_count);
          _this5.reviewTicketCount = _this5.toNumber(data.my_to_do_ticket_count);
          _this5.reviewQuotationCount = _this5.toNumber(data.my_to_do_question_count);
          _this5.reviewQuotationBindCount = _this5.toNumber(data.my_to_do_question_bind_count);
          _this5.reviewCount = _this5.reviewProjectCount + _this5.reviewMallCount + _this5.reviewPrintingCount + _this5.reviewTicketCount + _this5.reviewQuotationCount + _this5.reviewQuotationBindCount;
        });
      },
      getCounts: function getCounts() {
        if (this.hasAnyRole(permissions.myToDo)) {
          this.fetchMyToDoCount();
        }
        if (this.hasAnyRole(permissions.allToDo)) {
          this.fetchAllToDoCount();
        }
        if (this.hasAnyRole(permissions.myReview)) {
          this.fetchMyReviewCount();
        }
      },
      // 仅刷新指定顶部 tab 的计数（tabKey: myToDo/allToDo/myReview）
      getCountsForTab: function getCountsForTab(tabKey) {
        if (tabKey === 'myToDo' && this.hasAnyRole(permissions.myToDo)) {
          this.fetchMyToDoCount();
        } else if (tabKey === 'allToDo' && this.hasAnyRole(permissions.allToDo)) {
          this.fetchAllToDoCount();
        } else if (tabKey === 'myReview' && this.hasAnyRole(permissions.myReview)) {
          this.fetchMyReviewCount();
        }
      },
      // 子 tab 搜索/切换只刷新所属顶部 tab 的计数
      handleMyToDoCountChange: function handleMyToDoCountChange(_ref) {
        var tabKey = _ref.tabKey,
          searchForm = _ref.searchForm;
        if (this.hasAnyRole(permissions.myToDo)) {
          this.fetchMyToDoCount({
            tabKey: tabKey,
            searchForm: searchForm
          });
        }
      },
      handleAllToDoCountChange: function handleAllToDoCountChange(_ref2) {
        var tabKey = _ref2.tabKey,
          searchForm = _ref2.searchForm;
        if (this.hasAnyRole(permissions.allToDo)) {
          this.fetchAllToDoCount({
            tabKey: tabKey,
            searchForm: searchForm
          });
        }
      },
      handleMyReviewCountChange: function handleMyReviewCountChange(_ref3) {
        var tabKey = _ref3.tabKey,
          searchForm = _ref3.searchForm;
        if (this.hasAnyRole(permissions.myReview)) {
          this.fetchMyReviewCount({
            tabKey: tabKey,
            searchForm: searchForm
          });
        }
      }
    }
  };
}